import React, { useMemo } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useSelector, useDispatch } from 'react-redux';

import styles from './Store.module.css';
import CustomAppBar from '../../components/AppBar';
import StoreHeader from '../../components/StoreHeader';
import ProductContainer from '../../components/ProductContainer';
import { selectIsFetchingProducts, selectPods, selectShowLoadMore } from '../../redux/products/productsSelector';
import { getPodsThunk } from '../../redux/products/productsSlice';
import { selectMerchantSettings } from '../../redux/merchant/merchantSelector';
import { BRANDING_TYPE } from '../../globals';
import CategoryTabs from '../tabs/CategoryTabs';
import { Grid } from '@mui/material';

const Store = () => {
  console.log('Store page component triggered');
  const dispatch = useDispatch();
  const showLoadMore = useSelector(selectShowLoadMore);
  const isFetching = useSelector(selectIsFetchingProducts);
  const pods = useSelector(selectPods);
  const settings = useSelector(selectMerchantSettings);

  const loadMoreHandler = () => {
    dispatch(getPodsThunk());
  };

  const labels = useMemo(() => {
    const lang = navigator.language || navigator.userLanguage;
    if (lang === 'en' || lang.includes('en-')) return { loadMore: 'Load more' };
    if (lang === 'es' || lang.includes('es-')) return { loadMore: 'Cargar más' };
    if (lang === 'nl' || lang.includes('nl-')) return { loadMore: 'Meer laden' };
    return { loadMore: 'Load More' };
  }, []);

  return (
    <>
      <CssBaseline />
      <CustomAppBar />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}>
        <div className={styles.centered}>
          <Grid
            maxWidth="1536px"
            container
            spacing={2}
            columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 1 }}
            style={{ marginLeft: 8 }}>
            <CategoryTabs />
          </Grid>
        </div>
        <main className={styles.main}>
          {settings && settings.web_type === BRANDING_TYPE.full && (
            <Box sx={{ height: '42vh' }}>
              <StoreHeader />
            </Box>
          )}
          <div className={pods.length === 0 && isFetching ? '' : styles.centered}>
            <ProductContainer pods={pods} />
          </div>
          {showLoadMore && (
            <Button variant="contained" className={styles.loadMoreButton} color={'secondary'} onClick={loadMoreHandler}>
              {labels.loadMore}
            </Button>
          )}
        </main>
        <footer className={styles.centered + ' ' + styles.footer}>
          Augmented Reality powered by <a href="https://goyuge.com/">YUGE</a>
        </footer>
      </Box>
    </>
  );
};

export default Store;
